import React, { useEffect, memo, useRef } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { IHomeProps } from "../../models/interface";
import { Row, Col } from "antd";
import HomeProducts from "../../components/homeProducts";
import { setTitlePage } from "../../utils/helper";
import { FALL_TYPES, SECTION_POPUP, WIDTH_IPAD } from "../../common/constant";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import {
  getPopup,
  selectGift,
  selectPopup,
} from "../../redux/reducers/slice/common";
import { useSelector } from "react-redux";
import PopupHome from "../../components/popupHome";
import { useDispatch } from "react-redux";
import { getImageOrVideoPaths } from "../../shared/helpers";
import AnimationBackground from "../../components/animationBackground";
// import { setIsLoading } from "../../redux/reducers/slice/common";

const Home = memo((props: IHomeProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const popup: any = useSelector(selectPopup);
  const gift = useSelector(selectGift);
  const refPopup = useRef<any>(null);
  const { innerWidth, innerHeight } = window;
  const [topLeaf, setTopLeaf] = React.useState(0);
  const [topLeaf3, setTopLeaf3] = React.useState(0);
  const [topLeaf4, setTopLeaf4] = React.useState(0);
  const [topLeaf5, setTopLeaf5] = React.useState(0);

  const _icons = gift ? getImageOrVideoPaths(gift.sub_images) : [];
  const _fallType = gift ? gift.fall_type : FALL_TYPES.NORMAL_FALL;

  const leafStyle: ISectionCSS = {
    "--topLeaf": topLeaf.toString() + "px",
    "--topLeaf3": topLeaf3.toString() + "px",
    "--topLeaf4": topLeaf4.toString() + "px",
    "--topLeaf5": topLeaf5.toString() + "px",
  };

  useEffect(() => {
    setTitlePage(t("title_page_home"));
    window.addEventListener("scroll", onHandleScroll);

    return () => {
      window.removeEventListener("scroll", onHandleScroll);
    };
  }, []);

  useEffect(() => {
    if (!popup) {
      dispatch(getPopup(SECTION_POPUP));
    } else {
      if (refPopup && refPopup.current && !refPopup.current.visible) {
        refPopup.current.handleVisibleModal(true, popup);
      }
    }
  }, [popup]);

  const onHandleScroll = (e: any) => {
    const imageVideo: any = document.getElementById("imageVideo");
    const video: any = document.getElementById("video");

    if (imageVideo) {
      if (
        window.pageYOffset >=
          imageVideo?.offsetTop - imageVideo?.offsetHeight / 2.5 &&
        window.pageYOffset <=
          imageVideo?.offsetTop + imageVideo?.offsetHeight / 1.8
      ) {
        video?.play();
      } else {
        video?.pause();
      }
    }

    const windowScroll = window.scrollY;

    //Handle animation leaf
    const section1: any = document.querySelector(".kd-banner-wrap");
    const section2: any = document.querySelector(
      ".kd-category-description-container"
    );
    const section3: any = document.querySelector(".kd-section-category");
    // const section3: any = document.querySelector(".intro-section-wrap");

    if (!section1 || !section2 || !section3) return;

    let leafWrap: any = document.getElementById("leaf");
    let leaf1: any = document.getElementById("leaf-1");
    let leaf2: any = document.getElementById("leaf-2");
    let leaf3: any = document.getElementById("leaf-3");
    let leaf4: any = document.getElementById("leaf-4");
    let leaf5: any = document.getElementById("leaf-5");

    if (!leafWrap || !leaf1 || !leaf2 || !leaf3 || !leaf4 || !leaf5) return;

    const flag1 =
      innerWidth > WIDTH_IPAD ? 70 : section2.offsetTop - innerHeight + 120;
    const flag2 =
      innerWidth > WIDTH_IPAD
        ? section3.offsetTop - (innerHeight * 30) / 100
        : section2.offsetTop + (innerHeight * 70) / 100;
    const flag3 =
      innerWidth > WIDTH_IPAD
        ? section3.offsetTop + section3.offsetHeight / 2
        : flag2 + innerHeight - 120;

    if (!topLeaf || !topLeaf3 || !topLeaf5) {
      setTopLeaf(section1.offsetHeight);
      setTopLeaf3(
        innerWidth > WIDTH_IPAD
          ? section1.offsetHeight + section2.offsetHeight / 2
          : section1.offsetHeight + (innerHeight * 40) / 100
      );
      setTopLeaf4(
        innerWidth > WIDTH_IPAD
          ? section1.offsetHeight + section2.offsetHeight
          : section1.offsetHeight + (innerHeight * 10) / 100
      );
      setTopLeaf5(innerWidth > WIDTH_IPAD ? section3.offsetTop : flag2 + 500);
    }

    let l3f1Translate =
      innerWidth > WIDTH_IPAD
        ? "translate(105vw, 400px)"
        : "translate(105vw, 150vh)";
    let l4f1TranslateY = innerWidth > WIDTH_IPAD ? "-450px" : "75vh";
    let l5f3Translate =
      innerWidth > WIDTH_IPAD
        ? "translate(calc(102vw + 300px), 500px)"
        : "translate(calc(102vw + 300px), 500px)";

    if (windowScroll >= flag1 && windowScroll <= flag2) {
      leaf1.style.transition = "7s linear";
      leaf2.style.transition = "6s linear";
      leaf3.style.transition = "8s linear";
      leaf4.style.transition = "7s linear";
      leaf1.style.transform = "translate(105vw, 110vh)";
      leaf2.style.transform = "translate(62vw, 250px)";
      leaf3.style.transform = l3f1Translate;
      leaf4.style.transform = `translate(155vw, ${l4f1TranslateY})`;
    } else if (windowScroll >= flag2 && windowScroll < flag3) {
      leaf5.style.transform = l5f3Translate;
      leaf5.style.transition = "7s linear";
    } else if (windowScroll > flag3) {
      setTimeout(() => {
        leafWrap.remove();
      }, 7000);
    }
    //End
  };

  return (
    <>
      <Row justify="center" align="middle">
        <Col lg={24} md={24} sm={24} xs={24} className="kd-home-wrap">
          {_icons && _icons.length ? (
            <AnimationBackground
              icons={_icons}
              type={_fallType}
              leafStyle={leafStyle}
            />
          ) : null}
          <HomeProducts {...props} />
        </Col>
      </Row>
      <PopupHome ref={refPopup} />
    </>
  );
});

export default withTranslation()(Home);
